import React, { useState } from 'react';
import SpeakLoader from '../ui/speak-loader';

const TextToSpeech = ({ text }) => {
  const [isSpeaking, setIsSpeaking] = useState(false);

  const handleSpeak = () => {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'en-US';

    // Khi bắt đầu nói
    utterance.onstart = () => {
      setIsSpeaking(true);
    };

    // Khi kết thúc nói
    utterance.onend = () => {
      setIsSpeaking(false);
    };

    synth.speak(utterance);
  };

  return (
    <div>
      <button onClick={handleSpeak} disabled={isSpeaking}>
        {isSpeaking ? <SpeakLoader /> : '🔊 Nhấn để nghe'}
      </button>
    </div>
  );
};

export default TextToSpeech;
